import { useTranslation } from 'react-i18next';
import Link from '@mui/material/Link';
import { TextV2 } from '@insights-ltd/design-library/components';
import { PhysicalLocation, RemoteLocation } from 'api';

export const RemoteDetails = ({ location }: { location: RemoteLocation }) => {
  const { t } = useTranslation();

  return (
    <>
      <TextV2
        variant="bodyBold"
        sx={{
          textAlign: 'right',
        }}
      >
        {t('ui.event-management.events.location.type.remote-label')}
        {location.meetingLink && (
          <>
            &nbsp;-&nbsp;
            <TextV2 component="span" variant="h4" color="primary">
              <Link href={location.meetingLink}>
                {t('ui.event-management.events.location.meeting-link-label')}
              </Link>
            </TextV2>
          </>
        )}
      </TextV2>
      <TextV2
        variant="bodyBold"
        color="textSecondary"
        sx={{
          textAlign: 'right',
          overflowWrap: 'anywhere',
        }}
      >
        {location.details}
      </TextV2>
    </>
  );
};

export const PhysicalDetails = ({
  location,
}: {
  location: PhysicalLocation;
}) => {
  const { addressLine1, addressLine2, city, postcode, state, country } =
    location;
  const line3 = `${city} ${postcode}`;
  const formattedAddress = [addressLine1, addressLine2, line3, state, country]
    .filter((line) => line.length > 0)
    .map((line) => line.replace(/,\s*$/, ''))
    .join(', ');

  return (
    <TextV2
      variant="bodyBold"
      sx={{
        overflowWrap: 'anywhere',
      }}
    >
      {formattedAddress}
    </TextV2>
  );
};
